<template>
  <div v-if="visible" class="live-dashboard">
    <div class="live-dashboard__header">
      <div class="live-dashboard__title-wrap">
        <h2 class="live-dashboard__title">Dashboard en vivo - Preventivo/Correctivo</h2>
        <p class="live-dashboard__fetched-at">Actualizado: {{ fetchedAt }}</p>
        <p class="live-dashboard__countdown">Actualizacion en {{ countdownLabel }}</p>
      </div>
      <vm-button type="border" color="#374151" @click="$emit('close')">
        Cerrar
      </vm-button>
    </div>

    <div class="live-dashboard__content">
      <section class="live-dashboard__cards">
        <article class="live-dashboard__card">
          <span class="live-dashboard__card-label">Antes 12PM</span>
          <strong class="live-dashboard__card-value">{{ dailyBefore.percentage }}%</strong>
          <span class="live-dashboard__card-sub">{{ dailyBefore.reviewed_partidas }} / {{ dailyBefore.total_partidas }} partidas revisadas</span>
        </article>
        <article class="live-dashboard__card">
          <span class="live-dashboard__card-label">Despues 12PM</span>
          <strong class="live-dashboard__card-value">{{ dailyAfter.percentage }}%</strong>
          <span class="live-dashboard__card-sub">{{ dailyAfter.reviewed_partidas }} / {{ dailyAfter.total_partidas }} partidas revisadas</span>
        </article>
        <article class="live-dashboard__card">
          <span class="live-dashboard__card-label">Exito preventivo (Partidas)</span>
          <strong class="live-dashboard__card-value">{{ quarterlyLines.percentage }}%</strong>
          <span class="live-dashboard__card-sub">{{ quarterlyLines.successful }} / {{ quarterlyLines.total }} partidas</span>
        </article>
        <article class="live-dashboard__card">
          <span class="live-dashboard__card-label">Correctivos {{ quarterlyLabel }}</span>
          <strong class="live-dashboard__card-value">{{ quarterlyCorrectives }}</strong>
          <span class="live-dashboard__card-sub">Total partidas del trimestre</span>
        </article>
      </section>

      <section class="live-dashboard__table-section">
        <h3 class="live-dashboard__table-title">Historico de errores por usuario</h3>
        <vm-table class="live-dashboard__table" :data="historicalRows" max-height="calc(100vh - 330px)">
          <template slot="thead">
            <vm-th>Usuario</vm-th>
            <vm-th>Partidas escaneadas</vm-th>
            <vm-th>Errores preventivos</vm-th>
            <vm-th>Errores correctivos</vm-th>
            <vm-th>% Error preventivo</vm-th>
            <vm-th>% Error correctivo</vm-th>
          </template>
          <template slot-scope="{ data }">
            <vm-tr v-for="row in data" :key="row.user_name" :data="row">
              <vm-td>{{ row.user_name }}</vm-td>
              <vm-td>{{ row.total_reviews }}</vm-td>
              <vm-td>{{ row.total_preventive_errors }}</vm-td>
              <vm-td>{{ row.total_corrective_errors }}</vm-td>
              <vm-td>{{ row.preventive_error_rate }}%</vm-td>
              <vm-td>{{ row.corrective_error_rate }}%</vm-td>
            </vm-tr>
          </template>
        </vm-table>
      </section>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'

const { mapActions, mapGetters } = createNamespacedHelpers('Orders')

export default {
  name: 'LiveDashboardModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      countdown: 120,
      fetchTimer: null,
      countdownTimer: null
    }
  },
  computed: {
    ...mapGetters(['liveDashboard']),
    fetchedAt () {
      return (this.liveDashboard && this.liveDashboard.fetched_at) || '--/--/---- --:--'
    },
    dailyBefore () {
      const row = this.liveDashboard && this.liveDashboard.daily && this.liveDashboard.daily.before_noon
      return row || { percentage: 0, reviewed_partidas: 0, total_partidas: 0 }
    },
    dailyAfter () {
      const row = this.liveDashboard && this.liveDashboard.daily && this.liveDashboard.daily.after_noon
      return row || { percentage: 0, reviewed_partidas: 0, total_partidas: 0 }
    },
    quarterlyLabel () {
      return (this.liveDashboard && this.liveDashboard.quarterly && this.liveDashboard.quarterly.quarter_label) || ''
    },
    quarterlyLines () {
      const row = this.liveDashboard && this.liveDashboard.quarterly && this.liveDashboard.quarterly.preventive_success_by_partidas
      return row || { percentage: 0, successful: 0, total: 0 }
    },
    quarterlyCorrectives () {
      return (this.liveDashboard && this.liveDashboard.quarterly && this.liveDashboard.quarterly.total_correctives) || 0
    },
    historicalRows () {
      return (this.liveDashboard && this.liveDashboard.historical_errors_by_user) || []
    },
    countdownLabel () {
      const minutes = Math.floor(this.countdown / 60)
      const seconds = String(this.countdown % 60).padStart(2, '0')
      return minutes + ':' + seconds
    }
  },
  watch: {
    visible (value) {
      if (value) {
        this.startTimers()
      } else {
        this.stopTimers()
      }
    }
  },
  beforeDestroy () {
    this.stopTimers()
  },
  methods: {
    ...mapActions(['loadLiveDashboard']),
    async doFetch () {
      this.countdown = 120
      await this.loadLiveDashboard()
    },
    startTimers () {
      this.stopTimers()
      this.doFetch()
      this.fetchTimer = setInterval(() => {
        this.doFetch()
      }, 120000)
      this.countdownTimer = setInterval(() => {
        this.countdown = this.countdown > 0 ? this.countdown - 1 : 0
      }, 1000)
    },
    stopTimers () {
      if (this.fetchTimer) {
        clearInterval(this.fetchTimer)
        this.fetchTimer = null
      }
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }
    }
  }
}
</script>

<style lang="scss">
.live-dashboard {
  position: fixed;
  inset: 0;
  z-index: 99999;
  width: 100vw;
  height: 100vh;
  background: #f3f4f6;
  display: flex;
  flex-direction: column;
}

.live-dashboard__header {
  background: #ffffff;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.live-dashboard__title {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 800;
  color: #111827;
}

.live-dashboard__fetched-at {
  margin: 4px 0 0;
  font-size: 1rem;
  font-weight: 700;
  color: #374151;
}

.live-dashboard__countdown {
  margin: 2px 0 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: #6b7280;
}

.live-dashboard__content {
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  height: calc(100vh - 98px);
}

.live-dashboard__cards {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.live-dashboard__card {
  background: #ffffff;
  border-radius: 12px;
  padding: 18px 16px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.live-dashboard__card-label {
  color: #6b7280;
  font-size: 0.95rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.live-dashboard__card-value {
  color: #111827;
  font-size: 3.2rem;
  font-weight: 800;
  line-height: 1;
}

.live-dashboard__card-sub {
  color: #4b5563;
  font-size: 1.05rem;
  font-weight: 700;
}

.live-dashboard__table-section {
  min-height: 0;
  flex: 1;
  background: #ffffff;
  border-radius: 12px;
  padding: 14px 14px 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
}

.live-dashboard__table-title {
  margin: 0 0 8px;
  font-size: 1.15rem;
  font-weight: 800;
  color: #111827;
}

.live-dashboard__table {
  font-size: 1rem;
  font-weight: 700;
}

@media (max-width: 1399px) {
  .live-dashboard__cards {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .live-dashboard__content {
    padding: 12px;
    height: calc(100vh - 92px);
  }

  .live-dashboard__card-value {
    font-size: 2.5rem;
  }
}

@media (max-width: 600px) {
  .live-dashboard__cards {
    grid-template-columns: 1fr;
  }
}
</style>
